// Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.

// NOTE: Add the metric name on AWSErmineWebAppLoggingServiceCDK to create metric filters.
// There are 2 types of metric filters.
// 1. Publishing count/value metric. This is used for regular count and latency metrics.
// 2. Publishing HTTP status code metric. This is for capturing HTTP status code metrics.
export enum METRIC_NAME {
  COGNITO_CALL = "CognitoCallCount",
  COGNITO_FAILURE = "CognitoFailure",
  COGNITO_LOGIN_SUCCESS = "CognitoLoginSuccess",
  CLICK = "ClickCount",
  START_STREAMING = "StartStreaming",
  CREATE_REMOTE_BROWSER = "CreateRemoteBrowser",
  REFRESH = "RefreshCount",
  FROM_PHONE = "FromPhone",
  FROM_TABLET = "FromTablet",
  FROM_DESKTOP = "FromDesktop",
  HARDWARE_COMPATIBILITY_SUCCESS = "HardwareCompatibilitySuccess",
  HARDWARE_COMPATIBILITY_FAILURE = "HardwareCompatibilityFailure",
  DEVICE_BROWSER = "DeviceBrowser",
  DEVICE_OS = "DeviceOS",
  DEVICE_MODEL = "DeviceModel",
  DEVICE_TYPE = "DeviceType",
  DEVICE_TOUCHSCREEN = "DeviceTouchScreen",
}
